module.exports = __webpack_public_path__ + "img/crew4_7-8-2021.0843b108.jpg";